import { useEffect, useState } from "react";
import { blogs } from "../data/blogs";
import { useReveal } from "../hooks/useReveal";

export default function Blogs() {
  const ref = useReveal();
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (active) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [active]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <section id="blogs" className="section" ref={ref} data-testid="blogs-section">
      <div className="container">
        <div className="reveal reveal--up" style={{ maxWidth: 720 }}>
          <span className="eyebrow">Field Notes</span>
          <h2 className="section-title">Writings from the practice.</h2>
          <span className="divider-leaf">Six In-Depth Reads</span>
          <p className="section-lead" style={{ marginTop: 24 }}>
            Honest, evidence-based essays from the consulting room and the healing
            sanctuary — three on the cognitive mind, three on the energy body, all
            rooted in everyday clinical experience.
          </p>
        </div>

        <div className="blogs__grid stagger">
          {blogs.map((b) => (
            <article
              key={b.id}
              className="blog-card reveal reveal--up"
              onClick={() => setActive(b)}
              data-testid={`blog-card-${b.id}`}
            >
              <div className="blog-card__media">
                <img src={b.image} alt={b.title} loading="lazy" />
                <span className="blog-card__tag">{b.category}</span>
              </div>
              <div className="blog-card__body">
                <h3 className="blog-card__title">{b.title}</h3>
                <p className="blog-card__excerpt">{b.excerpt}</p>
                <span className="blog-card__more">
                  Read More <i className="fa-solid fa-arrow-right"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="modal"
          onClick={(e) => { if (e.target === e.currentTarget) setActive(null); }}
          data-testid="blog-modal"
        >
          <div className="modal__panel" role="dialog" aria-modal="true">
            <div className="modal__head">
              <button
                className="modal__back"
                onClick={() => setActive(null)}
                data-testid="blog-modal-back"
              >
                <i className="fa-solid fa-arrow-left"></i> Back to Blogs
              </button>
              <button
                className="modal__close"
                onClick={() => setActive(null)}
                aria-label="Close"
                data-testid="blog-modal-close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal__body">
              <div className="modal__hero">
                <img src={active.image} alt={active.title} />
              </div>
              <span className="modal__tag">{active.category}</span>
              <h2 className="modal__title">{active.title}</h2>
              <div className="modal__meta">
                <span><i className="fa-regular fa-clock" style={{ marginRight: 8 }}></i>{active.readTime}</span>
                <span>By Dr. Kalpana Randhawa</span>
              </div>
              <div
                className="modal__content"
                dangerouslySetInnerHTML={{ __html: active.body }}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
